// extracted by mini-css-extract-plugin
export default {"adornment":"styles_adornment__PLvFS","menu":"styles_menu__0ANRL","menu-item":"styles_menu-item__E3pUJ"};